<template>
    <div
        ref="turnstile"
        class="d-inline-block captcha-component captcha-turnstile"
        :class="{'border-error error-anchor': !validResponse}"
    ></div>
</template>

<script>
export default {
    name: 'Turnstile',
    props: {
        sitekey: {
            type: String,
            required: true,
        },
        language: {
            type: String,
            required: true,
        },
        captchaId: {
            type: String,
            required: false,
            default: null,
        },
        size: {
            required: false,
            type: String,
            default: 'normal',
            validator: function(value) {
                return ['normal', 'compact'].includes(value);
            }
        },
        theme: {
            required: false,
            type: String,
            default: 'light',
            validator: function(value) {
                return ['light', 'dark', 'auto'].includes(value);
            }
        },
        appearance: {
            required: false,
            type: String,
            default: 'always',
            validator: function(value) {
                return ['always', 'execute', 'interaction-only'].includes(value);
            }
        }
    },

    data: function(){
        return  {
            validResponse: true,
            isRendered: false,
            turnstile: null
        };
    },

    created() {
        this.validResponse = true;
        this.$store.dispatch("ui/recaptcha/setReady", {recaptchaId: this.captchaId, value: false});
        this.$store.dispatch("ui/recaptcha/setResponse", {response: null, recaptchaId: this.captchaId});
    },

    beforeDestroy() {
        this.$store.dispatch("ui/recaptcha/setReady", {recaptchaId: this.captchaId, value: false});
        this.$store.dispatch("ui/recaptcha/setResponse", {response: null, recaptchaId: this.captchaId});
    },

    methods: {
        onVerify(token) {
            console.log(`Verify turnstile (id: ${this.captchaId}, ts:${Date.now()}): ${token}`);
            this.validResponse = token;
            this.$store.dispatch("ui/recaptcha/setResponse", {response: token, recaptchaId: this.captchaId});
            this.$store.dispatch("ui/recaptcha/setReady", {recaptchaId: this.captchaId, value: true});
        },
        onExpired() {
            console.log(`Expired turnstile (id: ${this.captchaId}, ts:${Date.now()})`);
            this.$store.dispatch("ui/recaptcha/setResponse", {response: null, recaptchaId: this.captchaId});
        },
        onError(error) {
            this.validResponse = null;
            this.$store.dispatch("ui/recaptcha/setResponse", {response: null, recaptchaId: this.captchaId});
        },
        onRender() {
            this.validResponse = true;
            this.isRendered = true;
            this.$store.dispatch("ui/recaptcha/setReady", {recaptchaId: this.captchaId, value: true});
        },
        reset() {
            if (this.turnstile && window.turnstile) {
                window.turnstile.reset(this.turnstile);
            }
            this.onExpired();
        },
        initTurnstile() {
            this.validResponse = true;
            if (window.turnstile && this.$refs.turnstile) {
                this.turnstile = window.turnstile.render(this.$refs.turnstile, {
                    sitekey: this.sitekey,
                    theme: this.theme,
                    size: this.size,
                    appearance: this.appearance,
                    language: this.language,
                    callback: (token) => this.onVerify(token),
                    'expired-callback': () => this.onExpired(),
                    'error-callback': () => this.onError(),
                    'timeout-callback': () => this.onExpired(),
                    'before-interactive-callback': () => this.onRender()
                });
            }
        }
    },
    mounted() {
        // Load Turnstile script if not already loaded
        if (!window.turnstile) {
            import('../utils/scriptLoader.js').then(({ loadExternalScript }) => {
                loadExternalScript(
                    'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit',
                    () => this.initTurnstile()
                ).catch(err => console.error(err));
            });
        } else {
            this.initTurnstile();
        }
        this.$store.dispatch("ui/recaptcha/setCaptchaComponent", this);
    }
};
</script>
